import type { Image, TransformedProduct } from '@velasca/types'
import type { WishlistLineItemProps } from './WishlistLineItem'

// Extended product type with raw images for wishlist transformation
export interface TransformedProductWithRawImages extends TransformedProduct {
  rawImages: Image[]
  customProductType?: string
  frontImageIndex?: string
  creationTimestamp: number
}

export const transformProductToWishlistLineItem = (
  product: TransformedProductWithRawImages,
): WishlistLineItemProps => {
  const variant = product.variants[0] // Take the first variant

  // Handle price structure - could be number or object
  const getPrice = (
    priceValue: number | { max: number; min: number } | undefined,
  ) => {
    if (!priceValue) {
      return undefined
    }
    if (typeof priceValue === 'number') {
      return priceValue * 100
    }

    return priceValue.max * 100
  }

  // Use raw images from GraphQL instead of processed variant images
  const images = product.rawImages || []

  return {
    id: product.id,
    title: product.title,
    handle: product.handle,
    images,
    isGiftCard: product.isGiftCard,
    customProductType: product.customProductType,
    frontImageIndex: product.frontImageIndex,
    productType: product.productType,
    rawPrice: getPrice(variant?.price),
    rawCompareAtPrice: getPrice(variant?.compareAtPrice),
    material: variant?.description?.thin || undefined,
    color: variant?.description?.bold || undefined,
    seoCaption: variant?.seoCaption,
    sizes: product.sizes,
    storeExclusive: product.storeExclusive,
  }
}
